export const DOCUMENT_EXTENSIONS: string[] = [
  // Documents
  '.pdf',
  '.doc',
  '.docx',
  '.txt',
  '.rtf',
  '.odt',
  '.pptx',
  '.ppt',

  // Spreadsheets
  '.xlsx',
  '.xls',
  '.csv',
  '.tsv',

  // Code & Web files
  '.js',
  '.ts',
  '.jsx',
  '.tsx',
  '.json',
  '.py',
  '.java',
  '.html',
  '.htm',
  '.css',
  '.scss',
  '.sass',
  '.less',
  '.sql',
  '.c',
  '.cpp',
  '.h',
  '.hpp',
  '.cs',
  '.php',
  '.rb',
  '.go',
  '.rs',
  '.swift',
  '.kt',
  '.kts',
  '.sh',
  '.bash',
  '.xml',
  '.yaml',
  '.yml',
  '.md',
  '.env',
  '.angular',
  '.git',
  '.gitignore',
  '.dart',
  '.vue',
  '.toml',
  '.ini',

  // Archives
  '.zip',
  '.rar',
  '.7z',
  '.tar',
  '.gz',
  '.tgz',

  // Design & Vector files
  '.psd',
  '.ai',
  '.eps',
  '.fig',
  '.sketch',
  '.svg',
];
